module.exports = __webpack_public_path__ + "img/ve.f0124902.svg";